import React from 'react';
import { Box } from '@mui/material';
import BeehiveNav from '../../components/beehive/BeehiveNav';
import BeehiveFooter from '../../components/beehive/BeehiveFooter';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import SolutionSection from './SolutionSection';
import HowItWorksSection from './HowItWorksSection';
import ContactSection from './ContactSection';

export default function BeehiveLanding() {
  return (
    <Box>
      <BeehiveNav />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <HowItWorksSection />
      <ContactSection />
      <BeehiveFooter />
    </Box>
  );
}
